import React from "react";
import { motion } from "framer-motion";
import {
  Cog, Disc, Power, Settings, CircleStop, BatteryCharging,
  CircleDot, Activity, Zap, Truck, Droplet, Wrench,
} from "lucide-react";
import { useLang } from "../i18n";

const ICONS = {
  cog: Cog, disc: Disc, power: Power, settings: Settings, "circle-stop": CircleStop,
  "battery-charging": BatteryCharging, "circle-dot": CircleDot, activity: Activity,
  zap: Zap, truck: Truck, droplet: Droplet, wrench: Wrench,
};

export default function Services({ content }) {
  const { t, lang } = useLang();
  const services = content.services || [];

  return (
    <section id="services" className="relative z-10 bg-[#050505] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <div className="font-mono2 text-xs uppercase tracking-[0.3em] text-primary-red mb-4">/ {t.services.kicker}</div>
          <h2 className="font-display uppercase text-4xl sm:text-6xl text-white leading-[0.95]">{t.services.title}</h2>
          <p className="mt-5 font-body text-lg text-neutral-400">{t.services.sub}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-l border-t border-white/10">
          {services.map((s, i) => {
            const Icon = ICONS[s.icon] || Wrench;
            const name = lang === "en" ? s.name_en : s.name_es;
            const desc = lang === "en" ? s.desc_en : s.desc_es;
            return (
              <motion.div
                key={s.id || i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.4, delay: (i % 4) * 0.05, ease: "easeOut" }}
                className="group relative border-r border-b border-white/10 p-7 min-h-[220px] flex flex-col justify-between overflow-hidden hover:bg-primary-red transition-colors duration-200"
                data-testid={`service-${i}`}
              >
                <span className="font-mono2 text-xs text-neutral-600 group-hover:text-white/70 transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <Icon size={40} className="text-primary-red group-hover:text-white transition-colors duration-200 my-4" strokeWidth={1.6} />
                <div>
                  <h3 className="font-display uppercase text-2xl text-white leading-tight">{name}</h3>
                  <p className="mt-2 font-body text-sm text-neutral-500 group-hover:text-white/90 transition-colors">{desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
